import Global from "@/scripts/Global";
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'ChooseCreateChannel',
    data() {
        return {
        }
    },
    methods: {
        UsersList(){
          Global.globalValue(VueSignals.OVERLAY_TYPE,'users_list');
          Global.globalValue(VueSignals.SHOW_MODAL, true);
          this.closeModal();
        },
        CreateFolderModalCall(withChannel){
              Global.globalValue(VueSignals.OVERLAY_TYPE,'create_root_folder');
              Global.globalValue(VueSignals.SHOW_MODAL, true);
              Global.globalValue(VueSignals.OVERLAY_DATA, {"withChannel": withChannel});
              this.closeModal();
        },
        closeModal() {
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
        }
    }
}
